<template>
  <div class="content" v-if="loadOrganisation">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6">
      <card class="bg-transparent" >
        <template slot="header">
          <div>
            <h3 class="mb-0">Admin functions for {{ organisation.name }}</h3>
            <p class="text-sm mb-0">
              Import and recalculate data
            </p>
          </div>
        </template>
        <div>
          <b-row>
            <b-col cols="3">
              <b-card no-body>
                <b-card-header>
                  <h5 class="h3 mb-0">Import raw datas</h5>
                </b-card-header>
                <b-card-body>
                  <form>
                    <b-container fluid="xl">
                      <div>
                        <base-input label="Device">
                          <el-select width="120"
                                     filterable
                                     placeholder="Devices"
                                     v-model="importRawDatas.identifiers"
                                     :required=true
                                     v-if="loadDevices">
                            <el-option v-for="device in devices"
                                       :key="device.identifier"
                                       :label="device.identifier"
                                       :value="device.identifier">
                            </el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <div>
                        <base-input type="date" label="From" v-model="importRawDatas.from" :required=true />
                      </div>
                      <div>
                        <base-input type="date" label="Until" v-model="importRawDatas.until" :required=true />
                      </div>
                      <div>
                        <base-button size="sm" type="neutral" @click.native="handleImportRawDatas()">Import raw datas</base-button>
                      </div>
                    </b-container>
                  </form>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col cols="3">
              <b-card no-body>
                <b-card-header>
                  <h5 class="h3 mb-0">Recalculate query points</h5>
                </b-card-header>
                <b-card-body>
                  <form>
                    <b-container fluid="xl">
                      <div>
                        <base-input label="Asset">
                          <el-select width="120"
                                     filterable
                                     placeholder="Assets"
                                     v-model="recalculateQueryPoints.assetId"
                                     :required=true
                                     v-if="loadAssets">
                            <el-option v-for="asset in assets"
                                       :key="asset.name"
                                       :label="asset.name"
                                       :value="asset.id">
                            </el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <div>
                        <base-input type="date" label="From" v-model="recalculateQueryPoints.from" :required=true />
                      </div>
                      <div>
                        <base-input type="date" label="Until" v-model="recalculateQueryPoints.until" :required=true />
                      </div>
                      <div>
                        <base-button size="sm" type="neutral" @click.native="handleRecalculateQueryPoints()">Recalculate query points</base-button>
                      </div>
                    </b-container>
                  </form>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col cols="3">
              <b-card no-body>
                <b-card-header>
                  <h5 class="h3 mb-0">Recalculate driver links</h5>
                </b-card-header>
                <b-card-body>
                  <form>
                    <b-container fluid="xl">
                      <div>
                        <base-input label="Asset">
                          <el-select width="120"
                                     filterable
                                     placeholder="Assets"
                                     v-model="recalculateDriverLinks.assetId"
                                     :required=true
                                     v-if="loadAssets">
                            <el-option v-for="asset in assets"
                                       :key="asset.name"
                                       :label="asset.name"
                                       :value="asset.id">
                            </el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <div>
                        <base-input type="date" label="From" v-model="recalculateDriverLinks.from" :required=true />
                      </div>
                      <div>
                        <base-input type="date" label="Until" v-model="recalculateDriverLinks.until" :required=true />
                      </div>
                      <div>
                        <base-button size="sm" type="neutral" @click.native="handleRecalculateDriverLinks()">Recalculate driver links</base-button>
                      </div>
                    </b-container>
                  </form>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col cols="3">
              <b-card no-body>
                <b-card-header>
                  <h5 class="h3 mb-0">Delete all organisation data</h5>
                </b-card-header>
                <b-card-body>
                  <form>
                    <b-container fluid="xl">
                      <div>
                        <base-button size="sm" type="neutral" @click.native="handleDeleteAllOrganisationData(organisation)">Delete all organisation data</base-button>
                      </div>
                    </b-container>
                  </form>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </card>
    </b-container>
  </div>
</template>

<script>
import {Option, Select} from "element-ui";
import crudApi from "../../crud/crud-api";
import moment from "moment";
import swal from 'sweetalert2';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data: _ => ({
    organisation: {},
    assets: undefined,
    devices: undefined,
    deleteOrganisationData: undefined,
    importRawDatas: undefined,
    recalculateQueryPoints: undefined,
    recalculateDriverLinks: undefined
  }),
  created() {
    this.importRawDatas = {
      identifiers: [],
      from: moment().startOf('month').format().slice(0,10),
      until: moment().format().slice(0,10)
    },
    this.recalculateQueryPoints = {
      assetId: undefined,
      from: moment().startOf('month').format().slice(0,10),
      until: moment().format().slice(0,10)
    },
    this.recalculateDriverLinks = {
      assetId: undefined,
      from: moment().startOf('month').format().slice(0,10),
      until: moment().format().slice(0,10)
    }
  },
  computed: {
    loadOrganisation() {
      crudApi.getOrganisation(this.$store.state.auth.user.organisation_id).then(json => this.organisation = json.data ? json.data : json)

      return true
    },
    loadAssets() {
      crudApi.getAll('assets', this.$store.state.auth.user.organisation_id).then(json => this.assets = json.data ? json.data : json);

      return true
    },
    loadDevices() {
      crudApi.getAll('devices', this.$store.state.auth.user.organisation_id).then(json => this.devices = json.data ? json.data : json);

      return true
    }
  },
  methods: {
    handleImportRawDatas() {
      if (this.importRawDatas.identifiers) {
        let fromTime = new Date(this.importRawDatas.from+'T'+'00:00:00')
        let untilTime= new Date(this.importRawDatas.until+'T'+'00:00:00')

        crudApi.importRawDatas([this.importRawDatas.identifiers], fromTime, untilTime)
          .then(function () {
            swal.fire({
              title: 'Imported!',
              text: `Raw datas were successfully imported`,
              type: 'success',
              icon: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            });
          })
          .catch(function (error) {
            swal.fire({
              title: 'Error!',
              text: `Importing raw datas failed`,
              type: 'error',
              icon: 'warning',
              confirmButtonClass: 'btn btn-warning btn-fill',
              buttonsStyling: false
            });
          })
      }
    },
    handleRecalculateQueryPoints() {
      if (this.recalculateQueryPoints.assetId) {
        let fromTime = new Date(this.recalculateQueryPoints.from+'T'+'00:00:00')
        let untilTime = new Date(this.recalculateQueryPoints.until+'T'+'00:00:00')

        crudApi.recalculateQueryPoints(this.recalculateQueryPoints.assetId, fromTime, untilTime)
          .then(function () {
            swal.fire({
              title: 'Recalculated!',
              text: `The query points were successfully recalculated`,
              type: 'success',
              icon: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            });
          })
          .catch(function (error) {
            swal.fire({
              title: 'Error!',
              text: `Recalculating the query points failed`,
              type: 'error',
              icon: 'warning',
              confirmButtonClass: 'btn btn-warning btn-fill',
              buttonsStyling: false
            });
          })
      }
    },
    handleRecalculateDriverLinks() {
      if (this.recalculateDriverLinks.assetId) {
        let fromTime = new Date(this.recalculateDriverLinks.from+'T'+'00:00:00')
        let untilTime = new Date(this.recalculateDriverLinks.until+'T'+'00:00:00')

        crudApi.recalculateDriverLinks(this.recalculateDriverLinks.assetId, fromTime, untilTime)
          .then(function () {
            swal.fire({
              title: 'Recalculated!',
              text: `The driver links were successfully recalculated`,
              type: 'success',
              icon: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            });
          })
          .catch(function (error) {
            swal.fire({
              title: 'Error!',
              text: `Recalculating the driver links failed`,
              type: 'error',
              icon: 'warning',
              confirmButtonClass: 'btn btn-warning btn-fill',
              buttonsStyling: false
            });
          })
      }
    },
    handleDeleteAllOrganisationData(organisation) {
      swal.fire({
        title: `Delete : ${organisation.name}`,
        text: `This is *not* a soft delete !! All data will be deleted !!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          crudApi.deleteAllOrganisationData(this.$store.state.auth.user.organisation_id)
            .then(function () {
              swal.fire({
                title: 'Deleted!',
                text: `All organisation data was deleted`,
                type: 'success',
                icon: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
              });
            })
            .catch(function (error) {
              swal.fire({
                title: 'Error!',
                text: `Deleting all organisation data failed`,
                type: 'error',
                icon: 'warning',
                confirmButtonClass: 'btn btn-warning btn-fill',
                buttonsStyling: false
              });
            })
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
